<main class="container">
    <h2 class="title text-center">
        Submissão de cursos experimentais
    </h2>

    <div class="content">
        <div class="text-container text-justify">
            <p class="paragraph">
                A Secretaria de Educação Profissional e Tecnológica do Ministério da Educação (Setec/MEC) pretende inserir uma lista de cursos experimentais na nova versão do Catálogo Nacional de Cursos Superiores de Tecnologia.
            </p>
            <p class="paragraph">
                Para fazer parte desta lista, os cursos precisam atender aos seguintes critérios:
            </p>
            <ul class="items-list">
                <li>
                    Ter dados de matrículas publicados no Censo da Educação Superior do INEP;
                </li>
                <li>
                    Apresentar perfil profissional que seja diferente em pelo menos 70% de outros que já estejam incluídos no CNCST;
                </li>
                <li>
                    Não se constituir em especialização dos cursos já constantes no Catálogo.
                </li>
            </ul>

            <p class="paragraph">
                Os cursos propostos serão avaliados e, se atendidos os critérios, farão parte da versão final do CNCST a ser validada por este Ministério e, posteriormente, submetida ao Conselho Nacional de Educação. Somente instituições de ensino podem enviar propostas.
            </p>
            <button class="btn rounded-pill btn-lg btn-primary" routerLink="/inclusao-experimental">Submeter um curso</button>
        </div>
    </div>
</main>